import React from 'react';
import infographic from '../assets/strength-in-numbers-keys-hub.png';

const NFTSection: React.FC = () => {
  return (
    <section 
      id="about"
      className="w-full bg-[#0a192f]" 
      style={{ 
        scrollMarginTop: '120px', 
        paddingTop: '120px', 
        paddingBottom: '120px',
        marginBottom: '0px'
      }}
    >
      <div className="max-w-7xl mx-auto px-6" style={{ paddingBottom: '0px', marginBottom: '0px' }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:items-center" style={{ marginBottom: '0px' }}>
          {/* Left Column - Text Content */}
          <div className="text-gray-300 space-y-4 px-4 sm:px-8 md:px-12 lg:pl-20 lg:pr-8" style={{ paddingBottom: '0px' }}>
            <h1 className="font-bold mb-2" style={{ fontSize: '2.25rem' }}>Strength in Numbers</h1>
            <h2 className="text-lg mb-4 font-normal" style={{ color: '#60a5fa' }}>A Decentralized Portal for Collective Experiences</h2>
            
            <p className="text-sm leading-normal">
              BornFree is a member managed ecosystem where you support, access, and shape community-driven projects — from immersive events and products to media collaborations and place-based experiences.
            </p>
            
            <h3 className="font-bold pt-4" style={{ fontSize: '1.5rem', color: '#36a9f7' }}>Experience</h3>
            
            <p className="text-sm leading-normal">
              When you make an Experience Key, you join the BornFree community and receive annual stay credits. These credits unlock real experiences — from property access and creative retreats to collaborative projects and community-driven initiatives. Every action you take adds to the BornFree ecosystem, empowering transparency, sustainability, and shared growth.
            </p>
            
            <h4 className="text-lg font-semibold" style={{ color: '#60a5fa', marginBottom: '15px' }}>Powered by Participation</h4>
            
            <div className="w-full text-xs mt-4 mb-0">
              <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-8 pb-1 border-b border-gray-600">
                <div className="col-span-2 sm:col-span-1 text-left font-semibold text-blue-400">Action</div>
                <div className="col-span-3 sm:col-span-3 text-left font-semibold text-blue-400">Result</div>
              </div>
              <div className="divide-y divide-gray-700">
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-8 py-1">
                  <div className="col-span-2 sm:col-span-1 text-[10px] sm:text-xs leading-tight">Make Experience Key</div>
                  <div className="col-span-3 sm:col-span-3 text-gray-400 text-[10px] sm:text-xs">Get annual credits; Credits per night vary per property</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-8 py-1">
                  <div className="col-span-2 sm:col-span-1 text-[10px] sm:text-xs">Use credits</div>
                    <div className="col-span-3 sm:col-span-3 text-gray-400 text-[10px] sm:text-xs">Make Reservation, Project Keys; Buy, sell and merge</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-8 py-1">
                  <div className="col-span-2 sm:col-span-1 text-[10px] sm:text-xs">Choose place</div>
                  <div className="col-span-3 sm:col-span-3 text-gray-400 text-[10px] sm:text-xs">Blockchain scheduling accurate, fair and seamless</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-8 py-1">
                  <div className="col-span-2 sm:col-span-1 text-[10px] sm:text-xs leading-tight">Make Reservation Key</div>
                  <div className="col-span-3 sm:col-span-3 text-gray-400 text-[10px] sm:text-xs">Date & time set in metadata/QR codes give auto access</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-8 py-1">
                  <div className="col-span-2 sm:col-span-1 text-[10px] sm:text-xs">Project Key</div>
                  <div className="col-span-3 sm:col-span-3 text-gray-400 text-[10px] sm:text-xs">Events, media, products, and creative collaborations</div>
                </div>
                <div className="grid grid-cols-5 sm:grid-cols-4 gap-x-2 sm:gap-x-8 py-1">
                  <div className="col-span-2 sm:col-span-1 text-[10px] sm:text-xs">Vote</div>
                  <div className="col-span-3 sm:col-span-3 text-gray-400 text-[10px] sm:text-xs">Help choose new locations, experiences, or events</div>
                </div>
              </div>
            </div>
            
            <h3 className="font-bold text-gray-300" style={{ fontSize: '1.5rem', marginTop: '24px', marginBottom: '15px' }}>Feel the power of collective action</h3>
            
            <p className="text-sm leading-normal" style={{ color: '#a5acb3' }}>Our mission is to empower anyone to take control of their future through decentralized, transparent, and fair systems. By harnessing the power of the blockchain, we can create a more equitable world.</p>
          </div>
          
          {/* Right column — infographic */}
          <div className="flex items-center justify-center w-full px-2 sm:px-4">
            <img
              src={infographic}
              alt="BornFree keys flow: Experience, Project, Doc, and Reservation keys connect to Members"
              className="block h-auto w-full max-w-3xl object-contain"
              style={{
                mixBlendMode: 'lighten',
                filter: 'brightness(2.05) contrast(1.12)',
                maxHeight: 'min(900px, 94vh)',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NFTSection; 